import React from "react";
import "./ChooseUsPage.css";
import { FaShieldAlt, FaBolt } from "react-icons/fa";
import { MdAttachMoney } from "react-icons/md";
import phone from "../../assets/phone.png"
const ChooseUsPage = () => {
  return (
    <div className="why-container">
      {/* Left Content */}
      <div className="why-left">
        <h2>Why Choose Us</h2>

        <div className="why-item">
          <div className="icon-box blue">
            <FaShieldAlt />
          </div>
          <div>
            <h3>Safety First</h3>
            <p>
              All our drivers are thoroughly vetted and vehicles regularly
              maintained for your safety.
            </p>
          </div>
        </div>

        <div className="why-item">
          <div className="icon-box green">
            <MdAttachMoney />
          </div>
          <div>
            <h3>Affordable Pricing</h3>
            <p>
              Competitive rates with no surge pricing. Pay what you expect,
              every time.
            </p>
          </div>
        </div>

        <div className="why-item">
          <div className="icon-box purple">
            <FaBolt />
          </div>
          <div>
            <h3>Quick Service</h3>
            <p>
              Fast booking and quick pickup times to get you where you need to
              go.
            </p>
          </div>
        </div>
      </div>

      {/* Right Phone Image */}
      <div className="why-right">
        <img
          src={phone}
          alt="Mobile App"
        />
      </div>
    </div>
  );
};

export default ChooseUsPage;
